import { logGreyError } from 'owa-analytics';
import {
    getOSTimeZoneId,
    getTimeZoneRangeLoadState,
    isTimezoneAvailable,
    setLocalTimeZone,
} from 'owa-datetime-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { updateServiceConfig } from 'owa-service/lib/config';
import { updateUserConfiguration } from 'owa-session-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Update the mailbox time zone to the OS time zone only locally for Teams Calendar.
 */
export default function updateLocalMailboxTimeZone(): void {
    if (!isFeatureEnabled('teams-useOSTimeZone')) {
        return;
    }

    const userOptions = getUserConfiguration()?.UserOptions;
    const osTimeZone = getOSTimeZoneId();
    const shouldUpdateTimeZone = userOptions?.TimeZone !== osTimeZone;

    if (!shouldUpdateTimeZone) {
        return;
    }

    if (!osTimeZone || !isTimezoneAvailable(osTimeZone)) {
        /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
         * BASELINE: DO NOT COPY/PASTE!
         *	> Argument at index 1 for logGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
        logGreyError('OSTimeZoneNotAvailable', undefined, new Error('Timezone unavailable'), {
            OSTimeZone: osTimeZone,
            MailboxTimeZone: userOptions?.TimeZone,
            TimeZoneRangeLoadState: getTimeZoneRangeLoadState(),
        });

        return;
    }

    // Save
    updateServiceConfig({ timezone: osTimeZone });

    // Update owa-datetime
    setLocalTimeZone(osTimeZone, true /* isLocalUpdate */);

    // Update UserOptions
    updateUserConfiguration(config => {
        if (config.UserOptions) {
            config.UserOptions.TimeZone = osTimeZone;
        }
    });
}
